<template>
  <div class="pl-page">
    <pro-list-frame
      v-if="isDesktopListLayout"
      ref="plTable"
      :title="($t($route.name, { name: $store.state.studentLabel })) + ' ' + ((event ? event.name : ''))"
      icon="mdi-account-check-outline"
      :total="totalItems"
      :rows="items.length"
      :search.sync="search"
      :columns="toggleableHeaders"
      :hidden="hiddenColumns"
      :selected-count="(selected || []).length"
      :loading="loading"
      :cell-sel="cellSel"
      :fixed="!mobileShow"
      @refresh="getItems"
      @print="printStudio = true"
      @filter="filter = true"
      @toggle-column="toggleColumn"
      @show-all-columns="hiddenColumns = []"
      @cell-down="onCellDown"
      @cell-over="onCellOver"
      @clear-cells="clearCellSel"
      @clear-selection="selected = []"
    >
      <template #tools>
      <export-excel
        :data="excelItems"
        worksheet="abriron.com"
        name="data-ai.xls"
        type="xls"
      >
        <button type="button" class="pl-btn pl-btn--icon" :title="$t('excel')">
          <v-icon size="16" color="#2E7D32">mdi-file-excel-outline</v-icon>
        </button>
      </export-excel>
      </template>
      <template v-if="!eventProp" #top>
        <div class="aes-event-pick">
          <span class="aes-event-pick__icon" aria-hidden="true">
            <v-icon size="18">mdi-bookshelf</v-icon>
          </span>
          <div class="aes-event-pick__field">
            <autocomplete
              v-model="event"
              title="academyEventName"
              type="academyEvent"
              :value="event"
              :outlined="true"
            />
          </div>
        </div>
      </template>
      <v-data-table
        v-if="headers"
        ref="listTable"
        v-column-resize="academyAttendanceColumnPlugins"
        v-column-drag="academyAttendanceColumnPlugins"
        v-column-pin="academyAttendanceColumnPlugins"
        :height="mobileShow ? 323 : plTableH"
        fixed-header
        v-model="selected"
        :headers="tableHeaders"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="false"
        :show-select="showSelect"
        multi-sort
        dense
        item-key="id"
        :footer-props="plFooterProps"
      >
        <template v-slot:item.actions="{ item }">
          <div class="pl-action-cell">
            <v-menu
            offset-y
          >
            <template v-slot:activator="{ attrs, on }">
              <v-btn
                color="primary"
                v-bind="attrs"
                class="pl-action-cell__btn" icon x-small
                v-on="on"
              >
                <v-icon
                  medium
                >
                  mdi-dots-vertical
                </v-icon>
              </v-btn>
            </template>
                        <v-list dense>
              <v-list-item
                link
                @click="edit(item)"
              >
                <v-list-item-icon>
                  <v-icon class="mt-2">
                    mdi-clipboard-edit
                  </v-icon>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        icon
                        small
                        v-on="on"
                        @click.stop.prevent="newTab('customerEdit', item)"
                      >
                        <v-icon
                          small
                          color="primary"
                        >
                          mdi-content-duplicate
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('newTab') }}</span>
                  </v-tooltip>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('edit')" />
              </v-list-item>
              <v-list-item
                link
                @click="events(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-school-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('academyEventList')" />
              </v-list-item>
              <v-list-item
                link
                @click="turnover(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-recycle-variant</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('turnover')" />
              </v-list-item>
              <v-list-item
                link
                @click="payment(item, 'pay')"
              >
                <v-list-item-icon>
                  <v-icon>mdi-credit-card-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('payCash')" />
              </v-list-item>
              <v-list-item
                link
                @click="payment(item, 'recieve')"
              >
                <v-list-item-icon>
                  <v-icon>mdi-cash</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('cashReceive')" />
              </v-list-item>
              <v-list-item
                v-clipboard:copy="$baseURL + '/customer/edit/' + item.id"
                link
              >
                <v-list-item-icon>
                  <v-icon>mdi-link</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('copy-link')" />
              </v-list-item>
            </v-list>
          </v-menu>
            <span class="pl-action-cell__row">{{ parseInt(items.indexOf(item))+ parseInt(from) }}</span>
          </div>
        </template>
        <template v-slot:item.last_status.status_id="{ item }">
          <v-chip
            v-if="item.last_status && item.last_status.status"
            :color="item.last_status.status.color"
            label
            small
            style="cursor: pointer"
            class="px-1 mb-1"
          >
            <span class="px-2 white--text">
              {{ item.last_status.status.name }}
            </span>
          </v-chip>
        </template>
        <template v-slot:item.firstname="{ item }">
          <a @click="edit(item)">
            {{ item.firstname }} {{ (item.lastname ? item.lastname : '') }} {{ (item.code ? '(' + item.code + ')' : '') }}
          </a>
        </template>
        <template v-slot:item.attraction_method_id="{ item }">
          {{ (item.attraction_method ? item.attraction_method.name : '') }}
        </template>
        <template v-slot:item.task-relation="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                color="primary"
                x-small
                class="mx-1"
                v-on="on"
                @click="openTaskDialog(item)"
              >
                {{ $t('new-task') }}
                <v-icon
                  small
                >
                  mdi-plus
                </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('new-task') }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-badge
                color="error"
                overlap
                :content="item.taskCount"
                :value="item.taskCount"
              >
                <v-btn
                  v-if="item.taskCount > 0"
                  v-bind="attrs"
                  color="cyan"
                  x-small
                  v-on="on"
                  @click="openTaskDialogList(item)"
                >
                  {{ $t('tasks') }}
                  <v-icon small>
                    mdi-format-list-bulleted-square
                  </v-icon>
                </v-btn>
              </v-badge>
            </template>
            <span>{{ $t('tasks') }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.status="{ item }">
          <v-chip
            v-if="item.status === 'active'"
            small
            color="blue"
            outlined
          >
            {{ $t('active') }}
          </v-chip>
          <v-chip
            v-if="item.lead === 'active'"
            small
            color="orange"
            class="mx-1"
            outlined
          >
            {{ $t('lead') }}
          </v-chip>
        </template>
        <template v-slot:item.id="{ item }">
          <a @click="edit(item)">
            {{ item.id }}
          </a>
        </template>
        <template v-slot:item.phone="{ item }">
          <a
            v-if="item.phone"
            :href="'tel:' + item.phone"
          >
            <v-btn
              class="mx-2"
              dark
              text
              style="padding: 12px 4px !important;"
              color="primary"
            >
              {{ item.phone }}
              <v-icon
                dark
                small
                style="font-size: 12px"
              >
                mdi-phone
              </v-icon>
            </v-btn>
          </a>
        </template>
        <template v-slot:item.mobile="{ item }">
          <a
            v-if="item.mobile"
            :href="'tel:' + item.mobile"
          >
            <v-btn
              class="mx-2"
              dark
              text
              style="padding: 12px 4px !important;"
              color="primary"
            >
              {{ item.mobile }}
              <v-icon
                dark
                small
                style="font-size: 12px"
              >
                mdi-phone
              </v-icon>
            </v-btn>
          </a>
        </template>
        <template v-slot:item.remain="{ item }">
          <a
            v-if="item.remain"
            @click="turnover(item)"
          >
            <v-btn
              class="mx-2"
              dark
              text
              style="padding: 12px 4px !important;"
              color="primary"
            >
              {{ (item.remain ? $numberFormat(item.remain.remain) : 0) }}
            </v-btn>
          </a>
        </template>
        <template v-slot:item.state="{ item }">
          <v-chip
            v-show="item.remain && parseFloat(item.remain.remain) < 0"
            small
            color="blue"
            outlined
          >
            {{ $t('creditor') }}
          </v-chip>
          <v-chip
            v-show="item.remain && item.remain.remain > 0"
            small
            color="red"
            outlined
          >
            {{ $t('debtor') }}
          </v-chip>
          <v-chip
            v-show="item.remain && item.remain.remain == null"
            small
            color="green"
            outlined
          >
            {{ $t('clearing') }}
          </v-chip>
        </template>
        <template v-slot:item.rank="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                v-if="item.rank"
                class="mx-1"
                color="amber"
                text-color="brown"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon
                  left
                  size="15"
                >
                  mdi-language-ruby
                </v-icon>
                {{ item.rank }}
              </v-chip>
            </template>
            <span>{{ $t('point') }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.tags="{ item }">
          <pl-tags :tags="item.tags || []" />
        </template>
        <template v-slot:item.uid="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                icon
                v-on="on"
                @click="openPointDialog(item)"
              >
                <v-icon
                  color="green"
                >
                  mdi-account-school-outline
                </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('grade') }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="item.event.grade"
                v-bind="attrs"
                icon
                v-on="on"
                @click="sendSmsStudentGrade(item)"
              >
                <v-icon
                  color="blue"
                >
                  mdi-message-reply-text-outline
                </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('sendSmsGrade') }}</span>
          </v-tooltip>
        </template>
        <template v-slot:body.append>
          <tr
            v-if="isMobile || mobileShow"
            :class="{'v-data-table__mobile-table-row':isMobile}"
          >
            <td
              :colspan="isMobile ? 6 : Number(showHeaders.length) - 1"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              <strong>{{ $t('sum') }}</strong>
            </td>
            <td
              :colspan="isMobile ? 6 : 1"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              {{ (isMobile ? $t('amount') + ':' : '') }} {{ $numberFormat(totals.amount) }}
              {{ ($store.state.currency ? $store.state.currency.symbol : '') }}
            </td>
          </tr>
        </template>
        <template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
          {{ faNum(pageStart) }}–{{ faNum(pageStop) }} {{ $t("of") }} {{ faNum($numberFormat(itemsLength)) }}
        </template>
        <template v-slot:footer.prepend>
          <div
            v-if="!isMobile && !mobileShow"
            class="app-list-page-totals"
          >
            <span class="app-list-page-totals__label">{{ $t("sum") }}</span>
            <span class="app-list-page-totals__item app-list-page-totals__item--final">
              <span class="app-list-page-totals__key">{{ $t("amount") }}</span>
              <span class="app-list-page-totals__val">
                {{ $numberFormat(totals.amount) }}
                {{ ($store.state.currency ? $store.state.currency.symbol : '') }}
              </span>
            </span>
          </div>
          <div class="pl-goto">
            <span>{{ $t("goToPage") }}</span>
            <input v-model.number="options.page" type="number" min="1" :max="pageCount" class="pl-goto__input pl-num" />
            <span class="pl-num">/ {{ faNum(pageCount || 1) }}</span>
          </div>
        </template>
      </v-data-table>
    </pro-list-frame>
    <pro-list-mobile
      v-else
      :title="($t($route.name, { name: $store.state.studentLabel })) + ' ' + ((event ? event.name : ''))"
      :items="items"
      :total="totalItems"
      :loading="loading"
      :page="plPage"
      :page-count="pageCount || 1"
      :search.sync="search"
      :filterable="true"
      :printable="true"
      :card="plAutoCard"
      :actions="plAutoActions"
      @load-more="plLoadPage"
      @refresh="plLoadPage(1)"
      @print="printStudio = true"
      @filter="filter = true"
    />
    <print-studio
      v-model="printStudio"
      :report="plReportKey"
      :title="($t($route.name, { name: $store.state.studentLabel })) + ' ' + ((event ? event.name : ''))"
      :columns="plPrintCols"
      :source="plPrintSource"
      @error="serverErrorHandeler"
    />

      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="pointDialog"
      width="400"
    >
      <v-card>
        <v-col class="d-flex pb-0">
          <v-btn
            icon
            class="close-hover"
            @click="pointDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('grade') }}
          </p>
        </v-col>
        <v-col
          v-if="student"
          class="mt-3"
        >
          <v-text-field
            v-model="student.event.grade"
            :label="$t('grade')"
            height="20"
            dense
            outlined
            class="mb-1 dense"
            clearable
          />
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col
              cols="10"
              class="px-0"
            >
              <v-btn
                color="primary"
                small
                @click="gradeSubmit('deactive')"
              >
                {{ $t('submit') }}
              </v-btn>
              <v-btn
                color="green"
                style="margin-right: 8px !important;"
                small
                @click="gradeSubmit('active')"
              >
                {{ $t('submitAndSendSms') }}
              </v-btn>
            </v-col>
            <v-col
              cols="2"
              class="px-0"
            >
              <v-btn
                color="grey"
                outlined
                class="float-left"
                small
                @click="pointDialog = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="printDialog"
      width="70%"
    >
      <v-card>
        <v-col
          class="d-flex pb-0"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="printDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('print') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <print
            :header-prop="showHeaders"
            :items-prop="items"
            :title="$t($route.name)"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="deletDialog"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="deletDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img
            class="mx-auto"
            width="200"
            src="@/assets/stop.svg"
          />
        </v-col>
        <v-col
          class="mt-3 pr-7"
        >
          <p class="mx-auto font-weight-medium">
            {{ $t('are-you-sure-delete-this-case') }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                v-if="selected.length > 0"
                color="primary"
                @click="removegroup"
              >
                {{ $t('remove') }}
              </v-btn>
              <v-btn
                v-if="selected.length == 0"
                color="primary"
                @click="remove"
              >
                {{ $t('remove') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="filter"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="720"
      scrollable
      content-class="acf-wrap"
    >
      <div class="acf acf--compact" :style="proListRootStyle" dir="rtl">
        <header class="acf-head">
          <span class="acf-head__icon">
            <v-icon size="18">mdi-filter-variant</v-icon>
          </span>
          <div class="acf-head__titles">
            <div class="acf-head__title">{{ $t("academyEventStudentAttendanceFilterTitle") }}</div>
            <div class="acf-head__sub">
              <template v-if="activeFilterChips.length">
                <span class="acf-badge">{{ faNum(activeFilterChips.length) }}</span>
                {{ $t("accFilterActive") }}
              </template>
              <template v-else>{{ $t("accFilterNone") }}</template>
            </div>
          </div>
          <button type="button" class="acf-x" :title="$t('close')" @click="filter = false">
            <v-icon size="18">mdi-close</v-icon>
          </button>
        </header>

        <div class="acf-body">

          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-clipboard-check-outline</v-icon>
              {{ $t("academyFilterBasics") }}
            </div>
            <div class="acf-grid acf-grid--3">
              <autocomplete
                v-model="registerar"
                :title="$t('registerar')"
                type="partners"
                :multiple="true"
                :filter="true"
              />
              <tag v-model="tag" />

              <v-select
                v-model="selectedHeaders"
                :items="headers"
                :label="$t('sellFilterColumns')"
                dense
                outlined
                multiple
                return-object
                hide-details
              >
                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0" class="acf-sel">{{ item.text }}</span>
                  <span v-if="index === 1" class="acf-sel acf-sel--more">
                    +{{ faNum(selectedHeaders.length - 1) }}
                  </span>
                </template>
              </v-select>

            </div>
          </section>
        </div>

        <footer class="acf-foot">
          <button type="button" class="acf-btn acf-btn--primary" @click="getItems">
            <v-icon size="16">mdi-filter-check-outline</v-icon>
            {{ $t("accFilterApply") }}
          </button>
          <button
            type="button"
            class="acf-btn acf-btn--ghost"
            :disabled="!activeFilterChips.length"
            @click="resetFilters"
          >
            <v-icon size="16">mdi-filter-remove-outline</v-icon>
            {{ $t("accDocListClearFilters") }}
          </button>
          <span class="acf-spacer" />
          <button type="button" class="acf-btn" @click="filter = false">
            {{ $t("cancel") }}
          </button>
        </footer>
      </div>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="taskDialog"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="taskDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('task') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            ref="refTask"
            task-type="account"
            :ref-item="taskItem"
            ref-type="account"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="taskDialogList"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="taskDialogList = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('tasks') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task-list
            ref="refTaskList"
            type="account"
            :ref-id="refId"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="accountDialog"
      width="95%"
    >
      <v-card>
        <v-col class="d-flex pt-2 pb-0">
          <v-btn
            icon
            color="grey darken-2"
            @click="accountDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('new-account') }}
          </p>
        </v-col>
        <v-card-text class="pa-0">
          <div
            class="overflow-y-auto ma-2 mt-0"
            style=" height: 350px"
          >
            <account
              @close="accountDialog = false"
            />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--    upload dialog-->
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="uploadDialog"
      width="500"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="uploadDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col
          class="mt-0 pt-0 pr-7"
        >
          <upload
            type-prop="customer"
            :get-item="uploadDialog"
            @close="uploadDialog=false"
          />
        </v-col>
        <v-card-actions>
          <v-row class="ma-0" />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
    />
  </div>
</template>

<script>
  import Task from '../task/task'
  import TaskList from '../task/list'
  import Account from '../account/customer'
  import Upload from '../../components/general/upload/upload'
  import General from '../../../../Mixins/general'
  import Print from '../../components/general/Print/Index'
  // import pdfPrint from '../../components/general/Print/pdfPrintTable'
  import {
    applyColumnSettings,
    loadColumnSettings,
  } from '@/plugins/columnSettings/columnSettings'
  import { reorderPinnedHeaders } from '@/plugins/columnPin/columnPin'
  import ProList from "@/Mixins/proList";
  import ProListFrame from "@/components/proList/ProListFrame.vue";
  import ProListMobile from "@/components/proList/ProListMobile.vue";
  import PrintStudio from "@/modules/print/PrintStudio.vue";
  export default {
    name: 'AcademyEventStudentList',
    components: {
      ProListFrame,
      ProListMobile,
      PrintStudio,
      Snakbar: () => import('../../components/general/snakbar/snakbar'),
      Tag: () => import('../../components/general/Tag/tag'),
      autocomplete: () => import('../../components/general/patial/autocomplete'),
      Print,
      Task,
      // pdfPrint,
      TaskList,
      Upload,
      Account,
    },
    mixins: [General, ProList],
    props: ['input', 'type', 'data', 'integratorTypeProp', 'eventProp', 'studentProp'],
    data: () => ({
      selected: [],
      event: null,
      excelItems: null,
      category: null,
      integratorType: null,
      rangeDate: null,
      registerar: null,
      attractionMethod: null,
      customerStatusItems: null,
      financialStatusItems: null,
      pointDialog: false,
      printDialog: false,
      uploadDialog: false,
      accountDialog: false,
      deletDialog: false,
      filter: false,
      financialStatus: null,
      customerStatus: null,
      status: 'active',
      taskindex: 0,
      lead: null,
      refId: null,
      taskItem: null,
      model: null,
      from: 1,
      taskDialog: null,
      taskDialogList: null,
      showSelect: null,
      tag: null,
      temp: null,
      sellStatus: null,
      items: [],
      sortBy: [],
      dialog: null,
      timer: 0,
      totalItems: 0,
      pageCount: 1,
      snakbar: false,
      snakbarText: null,
      loading: true,
      options: {
        itemsPerPage: 5,
      },
      deleteItem: null,
      headers: null,
      personnel: null,
      student: null,
      search: null,
      renderTable: null,
      selectedHeaders: [],
    }),
    computed: {

      activeFilterChips () {
        var app = this

      var has = function (v) {
        if (Array.isArray(v)) return v.length > 0
        return v !== null && v !== undefined && v !== '' && v !== '0' && v !== 0
      }
      var show = function (v) {
        if (Array.isArray(v)) return v.length > 1 ? String(v.length) : show(v[0])
        if (v && typeof v === 'object') return v.name || v.text || v.label || ''
        return typeof v === 'number' || typeof v === 'string' ? String(v) : ''
      }

        var defs = [
          ['registerar', app.$t('registerar')],
          ['tag', app.$t('tag')],
        ]
        return defs
          .filter(function (d) {
            return has(app[d[0]])
          })
          .map(function (d) {
            return { key: d[0], label: d[1], value: d.length > 2 ? d[2] : show(app[d[0]]) }
          })
      },
      proListKey () {
        return this.academyAttendanceColumnPersistKey
      },
      proListLocked () {
        return this.academyAttendanceLockedColumns
      },
      academyAttendanceColumnPersistKey () {
        return 'academy-student-event-attendance-list-columns'
      },
      academyAttendanceLockedColumns () {
        var locked = ['actions', 'session.name']
        return this.showSelect ? ['__select'].concat(locked) : locked
      },
      academyAttendanceColumnPlugins () {
        var selectHeader = {
          value: '__select',
          text: '',
          width: 32,
          sortable: false,
          pinned: false,
          originalIndex: -1,
        }
        var visible = this.showSelect
          ? [selectHeader].concat(this.tableHeaders || [])
          : this.tableHeaders || []
        return {
          headers: this.headers,
          visibleHeaders: visible,
          locked: this.academyAttendanceLockedColumns,
          anchor: 'session.name',
          minWidth: 60,
          persistKey: this.academyAttendanceColumnPersistKey,
        }
      },
      isMobile () {
        return this.$vuetify.breakpoint.name === 'xs'
      },
      showHeaders () {
        var app = this
        return this.headers.filter(function (s) {
          if (app.type !== 'sell') {
            if (s.value === 'pre_invoice') {
            } else {
              return app.selectedHeaders.includes(s)
            }
          } else {
            return app.selectedHeaders.includes(s)
          }
        })
      },
      totals: function () {
        var app = this
        app.excelItems = []
        const totals = this.items.reduce((acc, d, index) => {
          app.excelItems.push({
            row: +index + +1,
            name: d.student && d.student.name,
            sessionName: d.session && d.session.name,
            date: d.session && d.session.jdate,
            place: d.session && d.session.place ? d.session.place.name : '',
          })
          return acc
        }, {
          amount: 0,
        })
        app.renderTable = true
        return totals
      },
    },
    watch: {
      event (val) {
        if (val) {
          this.getItems()
        } else {
          this.items = []
        }
      },
      eventProp (val) {
        this.event = null
        this.items = []
        if (val) {
          this.event = val
        }
      },
      taskDialogList (val, old) {
        if (!val) {
          this.getItems()
        }
      },
      taskDialog (val, old) {
        if (!val) {
          this.getItems()
        }
      },
      data (val, oldVal) {
        this.model = val.description
      },
      model () {
        this.$emit('input', this.model)
      },
      selected () {
        this.$emit('input', this.selected.text)
        if (this.selected.length > 0) {
          this.model = this.selected[0].text
          this.temp = this.selected[0].text
        }
        this.dialog = false
      },
      search () {
        var app = this
        app.loading = true
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.getItems()
        }, 1000)
      },
      options: {
        handler () {
          var app = this
          app.sortBy = []
          app.options.sortBy.map(function (value, key) {
            const index = app.headers.findIndex(h => h.value === value)
            app.sortBy.push(app.headers[index].table)
          })
          app.page = app.options.page
          app.itemsPerPage = app.options.itemsPerPage
          this.getItems()
        },
        deep: true,
      },
      sortBy () {
        const index = this.headers.findIndex(h => h.value === this.sortBy)
        if (index > -1) {
          this.sortBy = this.headers[index].table
        }
      },
    },
    activated () {
    // this.getItems()
    },
    beforeMount () {
      if (this.$route.params.financialStatus) {
        this.financialStatus = this.$route.params.financialStatus
      }
      this.customerStatusItems = [
        {
          value: 'lead',
          text: this.$t('lead'),
        },
        {
          value: 'on',
          text: this.$t('active'),
        },
      ]
      this.financialStatusItems = [
        {
          value: '>',
          text: this.$t('debtor'),
        },
        {
          value: '<',
          text: this.$t('creditor'),
        },
        {
          value: '=',
          text: this.$t('clearing'),
        },
      ]
      this.headers = [
        {
        text: this.$t("#"),
        align: "center",
        sortable: false,
        value: "actions",
        width: 42,
        class: "pl-action-col",
        cellClass: "pl-action-col",
      },
        {
          text: this.$t('sessionName'),
          sortable: false,
          value: 'session.name',
        },
        {
          text: this.$t('name'),
          sortable: true,
          value: 'student.name',
          table: 'users.name',
        },
        {
          text: this.$t('date'),
          sortable: true,
          value: 'session.jdate',
          table: 'academy_sessions.date',
        },
        {
          text: this.$t('place'),
          sortable: false,
          value: 'session.place.name',
        },
        {
          text: this.$t('startTime'),
          sortable: false,
          value: 'session.start_time',
        },
        {
          text: this.$t('national-code'),
          sortable: true,
          value: 'student.national_code',
          table: 'users.national_code',
        },
        {
          text: this.$t('phone'),
          sortable: true,
          value: 'student.phone',
          table: 'users.phone',
        },
        {
          text: this.$t('mobile'),
          sortable: true,
          value: 'student.mobile',
          table: 'users.mobile',
        },
      ]
    },
    mounted () {
      this.headersMap = this.headers
      this.selectedHeaders = this.headers
      reorderPinnedHeaders(this.headers, {
        locked: this.academyAttendanceLockedColumns,
        anchor: 'session.name',
      })
      this.loadAcademyAttendanceColumnSettings()
      if (this.eventProp) {
        this.event = this.eventProp
      }
    // this.getItems()
    },
    methods: {

      resetFilters () {
        var app = this
        ;['registerar', 'tag'].forEach(function (k) { app[k] = null })
      },
      loadAcademyAttendanceColumnSettings () {
        var app = this
        if (!app.headers || !app.headers.length) return
        loadColumnSettings(app, app.academyAttendanceColumnPersistKey).then(function (snapshot) {
          if (!snapshot || !snapshot.length) return
          applyColumnSettings(app.headers, snapshot, {
            locked: app.academyAttendanceLockedColumns,
            anchor: 'session.name',
          })
          app.$forceUpdate()
        })
      },
      sendSmsStudentGrade (item) {
        var app = this
        app.loading = true
        var data = {
          sendGradeSms: 'active',
          student: item,
        }
        app.$axios.post(this.$endpoint + 'academyStudents', data)
          .then(res => {
            res = res.data
            app.snakbarColor = 'green'
            app.snakbarText = this.$t('sent')
            app.snakbar = true
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      openPointDialog (item) {
        this.student = item
        this.pointDialog = true
      },
      openUploadDialog (item) {
        this.uploadDialog = true
      },
      openDeleteDialog (item) {
        this.deleteItem = item
        this.deletDialog = true
      },
      openTaskDialog (item) {
        if (this.$refs.refTask) {
          this.$refs.refTask.clearForm()
        }
        this.taskItem = item
        this.taskDialog = true
      },
      openTaskDialogList (item) {
        if (this.$refs.refTaskList) {
          this.$refs.refTaskList.getItems()
        }
        this.refId = item.id
        this.taskDialogList = true
      },
      isEnabled (slot) {
        return this.enabled === slot
      },
      edit (item) {
        this.$router.push({ name: 'customerEdit', params: { id: item.id } })
      },
      gradeSubmit (sms) {
        if (!this.event) {
          return false
        }
        var app = this
        app.pointDialog = false
        app.loading = true
        app.clearing = true
        app.showing = true
        var data = {
          setGrade: 'active',
          student: this.student,
          sms: sms,
        }
        app.$axios.post(this.$endpoint + 'academyStudents', data)
          .then(res => {
            res = res.data
            app.student = null
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      payment (item, type) {
        this.$router.push({ name: type, params: { accountProp: item } })
      },
      events (item) {
        this.$router.push({ name: 'academyEventList', params: { studentIdProp: item.id } })
      },
      getItems () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'academyStudents', {
          params: {
            getEventStudentsAttendance: 'active',
            event: app.event,
            student: app.studentProp,
            search: app.search,
            registerar: app.registerar,
            rangeDate: app.rangeDate,
            category: app.category,
            attractionMethod: app.attractionMethod,
            status: app.status,
            personnel: app.personnel,
            lead: app.lead,
            page: app.page,
            type: app.type,
            sortBy: app.sortBy,
            integratorType: app.integratorType,
            options: app.options,
            tag: app.tag,
            customerStatus: app.customerStatus,
            remainStatus: app.financialStatus,
          },
        })
          .then(res => {
            res = res.data
            app.items = res.data
            app.totalItems = res.total
            app.pageCount = res.last_page
            app.last_page = res.last_page
            app.from = res.from
          })
          .catch(err => {
            var error = err.response
            if (error.status === 401) {
              this.$router.push({ name: 'logout' })
            }
          })
          .finally(() => (app.loading = false))
      },
      remove () {
        var app = this
        if (!app.deleteItem) return false
        app.loading = true
        app.$axios.delete(this.$endpoint + 'customer/' + this.deleteItem.id)
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.getItems()
          })
          .catch(err => {
            this.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      removegroup () {
        var app = this
        app.loading = true
        app.$axios.delete(this.$endpoint + 'customer/0', {
          params: { deleteItems: app.selected },
        })
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.selected = []
            app.getItems()
          })
          .catch(err => {
            this.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      print () {
        this.$htmlToPaper('print')
      },
      turnover (item) {
        this.$router.push({ name: 'turnover', params: { accountProp: { fin_id: item.fin_id, name: item.name } } })
      },
    },
  }
</script>

<style scoped lang="scss">
@import "~@/sass/design-system/list/pro-list";

.aes-event-pick {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  margin: 0 0 2px;
  background: var(--pl-surface, #fff);
  border: 1px solid var(--pl-border, rgba(15, 23, 42, 0.08));
  border-radius: 6px;
  box-shadow: var(--pl-shadow, 0 1px 2px rgba(15, 23, 42, 0.04));
}
.aes-event-pick__icon {
  flex: 0 0 auto;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--pl-primary, #1976d2);
  background: var(--pl-primary-soft, rgba(25, 118, 210, 0.1));
}
.aes-event-pick__field {
  flex: 1 1 auto;
  max-width: 360px;
  min-width: 180px;
}
.aes-event-pick__field ::v-deep .v-input {
  margin: 0 !important;
  padding: 0 !important;
  height: auto !important;
}
.aes-event-pick__field ::v-deep .v-input__control {
  min-height: 0 !important;
}
.aes-event-pick__field ::v-deep .v-text-field--outlined.v-input--dense .v-input__slot {
  min-height: 32px !important;
  margin-bottom: 0 !important;
}
.aes-event-pick__field ::v-deep .v-text-field--outlined fieldset {
  border-radius: 6px !important;
  border-color: var(--pl-border-strong, #cbd5e1) !important;
}
.aes-event-pick__field ::v-deep .v-label {
  font-size: 12px !important;
}
.theme--dark .aes-event-pick {
  background: var(--pl-surface, #1e1e1e);
  border-color: var(--pl-border, #2e2e2e);
}

.v-badge__badge {
  height: 16px !important;
  min-width: 16px !important;
  padding: 4px 6px !important;
}
.v-data-table > .v-data-table__wrapper .v-data-table__mobile-row {
  height: initial;
  min-height: 32px !important;
}
</style>
